// EV-04 / EV-05 personal alarms are identified by a 15-digit IMEI carried in
// the device `mac` field. Keep the "which types are IMEI" rule in one place so
// a future 4G model is a one-line change.
const IMEI_TYPES = new Set(['ev04', 'ev05', 'ev07b']);

export function isImeiType(value) {
  return IMEI_TYPES.has(value);
}

export function cleanImei(raw) {
  return String(raw || '').replace(/[\s-]/g, '');
}

// 15 digits + valid Luhn check digit.
export function isValidImei(raw) {
  const s = cleanImei(raw);
  if (!/^\d{15}$/.test(s)) return false;
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    let d = s.charCodeAt(i) - 48;
    if (i % 2 === 1) { d *= 2; if (d > 9) d -= 9; }
    sum += d;
  }
  return sum % 10 === 0;
}
